<script>
import Spacer from 'linna/components/Spacer'
import formatFileSize from 'linna/util/formatFileSize'

import fileTypes from '@/config/fileTypes'

import Buttons from '@/components/snippets/Buttons'
import GlitchedImage from '@/components/snippets/GlitchedImage'
import StyledButton from '@/components/snippets/StyledButton'

import ImageFileViewer from '@/components/widgets/ImageFileViewer'
import TextFileViewer from '@/components/widgets/TextFileViewer'

import getFileData from '@/util/getFileData'

export default {
  name: 'ViewFile',

  props: {
    fileSlug: {
      type: String,
      required: true
    }
  },

  components: {
    ImageFileViewer,
    TextFileViewer,

    Buttons,
    GlitchedImage,
    Spacer,
    StyledButton
  },

  computed: {

    file () {
      const file = this.$store.getters.fileBySlug(this.fileSlug)

      if (!file) {
        throw new Error('Missing file')
      }

      return file
    },

    component () {
      return fileTypes[this.file.type].viewerComponent
    },

    fileData () {
      return getFileData(this.file.fileSlug)
    },

    size () {
      return formatFileSize(this.file.size)
    }

  }

}
</script>

<template>
  <div class="c-view-file">
    <div class="c-view-file-content">

      <div class="c-view-file-actions">

        <buttons>

          <styled-button
            :to="{
              name: 'files'
            }"
          >
            &lt; All
          </styled-button>

        </buttons>

        <spacer />

        <div class="c-view-file-name">
          {{ file.name }}{{ file.fileExtension }}
        </div>

        <spacer />

        <div class="c-view-file-size">
          {{ size }}
        </div>

      </div>

      <component
        :is="component"
        :file="file"
        :data="fileData"
        class="c-view-file-viewer"
      />

    </div>
  </div>
</template>

<style lang="scss">

.c-view-file {
  @include fill-relative;
}

.c-view-file-content {
  @include flex;
  @include flex-vertical;
  @include keep-full-center;
  height: 100%;
  width: $width-content-loose;
  max-width: 100%
}

.c-view-file-actions {
  @include flex-fixed;
  @include flex;
  @include push-pad-bottom-even;
}

.c-view-file-viewer {
  @include flex-fluid;
  @include relative;
  @include scroll;
}

</style>
